import { isNumber } from 'common/utils';
import { StorageService, axios } from 'libs';

const resource = '/entidades';

export const findAll = () => {
  return axios.get(resource);
};

export const findById = id => {
  return axios.get(`${resource}/${id}`);
};

export const getEntidadePrincipal = () => {
  return axios.get(`${resource}/entidade-principal`);
};

export const getEntidadeLogada = () => {
  const entidadeKey = StorageService.getItem('entidade');
  return isNumber(entidadeKey) ? findById(entidadeKey) : getEntidadePrincipal();
};
